import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { DwellingApiService } from '../index';
import { IDwelling, IDwellingInput, WITHDRAW_DWELLING_MUTATION } from '@ebb-v2/ebb-integration';

import { Apollo} from 'apollo-angular';
import { ListDwellingsQuery, GetDwellingByIdQuery, AnyDwellingsQuery } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export class DwellingGqlService implements DwellingApiService {
  constructor(private apollo: Apollo) {}

  public getDwellingList(): Observable<IDwelling[]> {
    return this.apollo
      .watchQuery({
        query: ListDwellingsQuery
      })
      .valueChanges.pipe(
        map(result => result.data['dwellings'] as IDwelling[]),
        take(1)
      );
  }

  public getDwelling(id: string): Observable<IDwelling> {
    return this.apollo
      .watchQuery({
        query: GetDwellingByIdQuery,
        variables: {
          id: id
        }
      })
      .valueChanges.pipe(
        map(result => result.data['dwelling'] as IDwelling),
        take(1)
      );
  }
 
  public withdrawDwelling(
    dwellingInput: IDwellingInput,
    dwellingId: string
  ): Observable<any> {
    return this.apollo
      .mutate({
        mutation: WITHDRAW_DWELLING_MUTATION,
        variables: {
          dwellingInput,
          dwellingId
        }
      })
      .pipe(map(result => result.data['withdrawDwelling'].id as string));
  }

  public anyDwellings(email: string, programCycleKey: string): Observable<boolean> {
     return this.apollo
      .watchQuery({
        query: AnyDwellingsQuery,
        fetchPolicy: 'network-only',
        variables: {
          email: email,
          programCycleKey: programCycleKey,
        }
      })
      .valueChanges
      .pipe(map(result => result.data['anydwellings'] as boolean), take(1));
  }

}
